import React, { useState } from 'react';
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../core/hooks/useAuth';
import { UsersMaganementScreen } from '../domains/users/screens/UserManagementScreen';
import { AppHeader, AppScreen } from './AppHeader';
import './HomePage.css';
import { StatsPage } from './StatsPage';
import { SupportPage } from './SupportPage';
import { SyncActionPage } from './SyncActionPage';

export const HomePage: React.FC = () => {
    const navigate = useNavigate();
    const [activeScreen, setActiveScreen] = useState<AppScreen>('users');

    const { logout } = useAuth({
        onAuthChange: (isAuthenticated) => {
            if (!isAuthenticated) navigate('/login');
        },
    });

    const handleLogout = async () => {
        try {
            await logout();
        } catch (err) {
            console.error('Ошибка выхода:', err);
        }
    };

    return (
        <div className="home-page">
            <AppHeader
                activeScreen={activeScreen}
                onNavigate={setActiveScreen}
                onLogout={handleLogout}
            />

            <div className="home-content">
                {activeScreen === 'users' && <UsersMaganementScreen />}
                {activeScreen === 'sync'  && <SyncActionPage />}
                {activeScreen === 'stats' && <StatsPage />}
                {activeScreen === 'support' && <SupportPage />}
            </div>
        </div>
    );
};
